import React, { useState, useEffect } from 'react';
import { PivotTable } from 'src/mtska-frontend-app-component';
import { useTranslation } from 'react-i18next';
import { useSettingContextInComponent, useSettingsContext } from "src/mtska-frontend-app-scaffolding";
import JSONPretty from 'react-json-pretty'

const Pivot = ({ dataProviderName, filters: defaultFilters }) => {
    const { t } = useTranslation();
    const { addFilter } = useSettingsContext(dataProviderName);
    const { filterModel, drawable } = useSettingContextInComponent(dataProviderName, defaultFilters);
    const [localDrawable, setLocalDrawable] = useState();
    const [localFilterModel, setLocalFilterModel] = useState();

    useEffect(() => {
        if (!filterModel) return;
        const localFilterModel = { items: [...filterModel.items, { field: "status", operator: "equals", value: "accepted" }] }
        setLocalFilterModel(localFilterModel);
        setLocalDrawable(true);
    }, [filterModel])

    return (localDrawable &&
        <PivotTable
            dataProviderName="statisticsviews/proposal/pivot/views_opportunities_proposal"
            filters={localFilterModel}
            format="number"
            rows={[
                { field: '_related_area_name', sort: 'asc' },
                { field: '_related_shop_name', sort: 'asc' }
            ]}
            values={[
                {
                    field: 'totalCommissionValue_numeric',
                    aggregate: 'sum',
                    format: 'currency',
                    compactformat: false,
                    decimaldigits: 'standard'
                }
            ]}
            columns={[
                { field: 'registered_at', bucket: 'month' }
            ]}
        />
    )
}

export default Pivot;
